import {Component, OnInit} from "@angular/core";
import {IWorkout} from "../../../shared/interfaces/IWorkout";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkoutsControllerService} from "../../../core/api/controllers/workouts/workouts-controller.service";
import {NotificationService} from "../../../core/services/notification.service";
import {
  ExercisesCategoryFormFactory,
  ExercisesCategoryFormHelper,
  IPlaylistForm,
  WorkoutFormFactory
} from "../workout-form/WorkoutFormFactory";
import {IWorkoutPayload} from "../workout-form/workout-form.component";
import {ExercisesControllerService} from "../../../core/api/controllers/exercises-controller/exercises-controller.service";
import {WorkoutFormHelper} from "../workout-form/WorkoutFormHelper";
import {Subject} from "rxjs";
import {FormGroup} from "@angular/forms";
import {IPlaylist} from "../../../shared/interfaces/IPlaylist";
import {_pt} from "../../../core/services/preview-text/helpers/preview-text.function";

@Component({
  selector: 'app-edit-workout',
  templateUrl: './edit-workout.component.html',
  styleUrls: ['./edit-workout.component.scss']
})
export class EditWorkoutComponent implements OnInit{
  workout: IWorkout;
  workoutForm = WorkoutFormFactory.create();
  isLoading = false;
  _refreshSelectedConfigsSubject = new Subject();
  _refreshSelectedConfigs = this._refreshSelectedConfigsSubject.asObservable();

  constructor(
      private route: ActivatedRoute,
      private workoutsController: WorkoutsControllerService,
      private notificationService: NotificationService,
      private exercisesController: ExercisesControllerService,
      private router: Router
  ) {}

  ngOnInit(): void {
    this.getWorkout();
  }

  getExerciseCategories(): void {
    this.isLoading = true;
    this.exercisesController.getCategories().subscribe({
      next: (res) => {
        this.workoutForm.controls.playlists.controls.forEach(playlistForm => {
          res.forEach(category => {
            const newCategoryForm = ExercisesCategoryFormFactory.create();
            ExercisesCategoryFormHelper.patchFormValue(newCategoryForm, category);
            playlistForm.controls.exerciseCategories.push(newCategoryForm);
          })
        })
        this.selectExercises();
        this.isLoading = false;
      },
      error: (error) => {
        this.notificationService.error(error);
        this.isLoading = false;
      }
    });
  }

  selectExercises(): void {
    this.workout.playlists.forEach(playlist => {
      const playlistForm = this.findPlaylistForm(playlist);
      if(playlistForm === null) return;
      playlist.playlistConfigs.forEach((config, index) => {
        const playlistConfigId = config.id;
        const configId = config.configId;
        const configOrder = config.order;
        const configSets = config.sets;
        this.selectExercisePlaylistConfig(playlistForm , configId ,playlistConfigId, configOrder, configSets);
      })
    })
    this._refreshSelectedConfigsSubject.next();
  }

  findPlaylistForm(playlist: IPlaylist): FormGroup<IPlaylistForm> {
    return this.workoutForm.controls.playlists.controls.find(playlistForm => playlistForm.controls.id.value === playlist.id)
  }


  selectExercisePlaylistConfig(playlist: FormGroup<IPlaylistForm>, configId: string,playlistConfigId: string , configOrder: number, configSets: number): void {
    playlist.controls.exerciseCategories.controls.forEach(exerciseCategory => {
      exerciseCategory.controls.exercises.controls.forEach(exercise => {
        exercise.controls.regularExercise.controls.configs.controls.forEach(config => {
          if(config.controls.id.value === configId) {
            config.controls.playlistConfigId.setValue(playlistConfigId);
            config.controls.isSelected.setValue(true);
            config.controls.order.setValue(configOrder);
            config.controls.sets.setValue(configSets);
          }
        })
        exercise.controls.pairedExercise.controls.pairedExerciseConfigs.controls.forEach(config => {
          if(config.controls.id.value === configId) {
            config.controls.playlistConfigId.setValue(playlistConfigId);
            config.controls.isSelected.setValue(true);
            config.controls.order.setValue(configOrder);
            config.controls.sets.setValue(configSets);
          }
        })
      })
    })
  }

  getWorkout(): void {
    this.isLoading = true;
    this.workoutsController.getWorkout(this.route.snapshot.params['id']).subscribe({
      next: (res) => {
        this.workout = res;
        WorkoutFormHelper.patchValue(this.workoutForm, this.workout)
        this.getExerciseCategories();
      },
      error: (err) => {
        this.notificationService.error(_pt("get_workout_error"));
        this.isLoading = false;
        this.router.navigate([_pt('sidebar_workouts_link')]);
      }
    })
  }

  editWorkout(newWorkout: IWorkoutPayload): void {
    this.isLoading = true;
    this.workoutsController.editWorkout(this.route.snapshot.params["id"], newWorkout).subscribe({
      next: () => {
        this.notificationService.success(_pt('workout_edited_success'))
        this.router.navigateByUrl(_pt('sidebar_workouts_link'));
        this.isLoading = false;
      },
      error: (error: any) => {
        this.notificationService.error(error);
        this.isLoading = false;
      }
    })
  }


  goToWorkouts(): void {
    this.router.navigateByUrl(_pt('sidebar_workouts_link'));
  }

    protected readonly _pt = _pt;
}
